import { createHistory } from '@reach/router'

// @ts-ignore
const history = createHistory(window)

export default history
